import { render, staticRenderFns } from "./ChiSono.vue?vue&type=template&id=36423fb7&"
import script from "./ChiSono.vue?vue&type=script&lang=js&"
export * from "./ChiSono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports